import { render, staticRenderFns } from "./DigitalApplicationDisclaimer.vue?vue&type=template&id=71a661c9&scoped=true"
var script = {}
import style0 from "./DigitalApplicationDisclaimer.vue?vue&type=style&index=0&id=71a661c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a661c9",
  null
  
)

export default component.exports